import { SOURCES, MAP_DATA_SOURCE } from '../../constants/map';

export const addLayer = ({ map, source, kyc = false }) => {
	if (source === SOURCES.route) return routeLayer(map);

	if (source === SOURCES.earthquakes) return earthquakesLayer({ map, kyc });

	if (source === MAP_DATA_SOURCE.botLocation) return botLocationLayer(map);
};

const routeLayer = (map) =>
	map.addLayer({
		id: SOURCES.route,
		type: 'line',
		source: SOURCES.route,
		layout: {
			'line-join': 'round',
			'line-cap': 'round'
		},
		paint: {
			'line-color': '#FCF552',
			'line-width': {
				base: 1.5,
				stops: [
					[8, 8],
					[8, 8]
				]
			},
			'line-dasharray': [0.1, 2.5]
		}
	});

const earthquakesLayer = ({ map, kyc }) => {
	map.addLayer({
		id: 'clusters',
		type: 'symbol',
		source: SOURCES.earthquakes,
		filter: ['has', 'point_count'],
		layout: {
			'icon-image': 'allHex',
			'icon-size': 0.75,
			'icon-allow-overlap': true
		}
	});

	map.addLayer({
		id: 'cluster-count',
		type: 'symbol',
		source: SOURCES.earthquakes,
		layout: {
			'text-field': '{point_count}',
			'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
			'text-size': 16
		}
	});

	if (kyc) {
		map.addLayer({
			id: 'unclustered-point',
			type: 'symbol',
			source: SOURCES.earthquakes,
			filter: ['!has', 'point_count'],
			layout: {
				'icon-image': [
					'match',
					['get', 'status'],
					'mission_ready',
					'online',
					'mission_in_progress',
					'inProgress',
					'offline',
					'offline',
					''
				],
				'icon-size': 1.5,
				'icon-ignore-placement': true,
				'icon-allow-overlap': true
			}
		});
	} else {
		map.addLayer({
			id: 'unclustered-point',
			type: 'symbol',
			source: SOURCES.earthquakes,
			filter: ['!has', 'point_count'],
			layout: {
				'icon-image': [
					'case',
					['==', ['get', 'kyc_required'], true],
					'verified',
					[
						'match',
						['get', 'status'],
						'mission_ready',
						'online',
						'mission_in_progress',
						'inProgress',
						'offline',
						'offline',
						''
					]
				],
				'icon-size': ['case', ['==', ['get', 'kyc_required'], true], 0.8, 1.5],
				'icon-ignore-placement': true,
				'icon-allow-overlap': true
			}
		});
	}
};

const botLocationLayer = (map) => {
	map.addLayer({
		id: MAP_DATA_SOURCE.botLocation,
		type: 'circle',
		source: MAP_DATA_SOURCE.botLocation,
		paint: {
			'circle-radius': 8,
			'circle-color': '#007cbf',
			'circle-stroke-width': 2,
			'circle-stroke-color': '#ffffff'
		}
	});

	map.addLayer({
		id: `${MAP_DATA_SOURCE.botLocation}-label`,
		type: 'symbol',
		source: MAP_DATA_SOURCE.botLocation,
		layout: {
			'text-field': ['get', 'name'],
			'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
			'text-size': 12,
			'text-offset': [0, 2],
			'text-anchor': 'top'
		},
		paint: {
			'text-color': '#000000',
			'text-halo-color': '#ffffff',
			'text-halo-width': 1
		}
	});
};
